// extracted by mini-css-extract-plugin
module.exports = {"button":"button-arrow_button__SSmuz","one":"button-arrow_one__mFI8_","light":"button-arrow_light__7TroN","dark":"button-arrow_dark__Omd2o","two":"button-arrow_two__R_L2G"};